import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginParams } from 'app/model/authen/authen';
import { Observable } from 'rxjs/Observable';
import { CLIENT_ID, Language } from 'app/model/constant';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { accountFrontend, redirectURIV2 } from 'environments/properties';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable()
export class ExtraGuard implements CanActivate {

  public loginParams = new LoginParams();

  constructor(
    private utilitiesService: UtilitiesService,
    private authService: AuthenticationService,
    private router: Router,
    private appConfigService: AppConfigService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (state.url.includes('/action') && state.root.queryParams.action && state.root.queryParams.lang) {
      const authorizeRequest = this.authService.generateAuthorizeRequest();
      authorizeRequest.lang = state.root.queryParams.lang;
      const queryString = this.utilitiesService.objectToQueryString({
        action: state.root.queryParams.action,
        ...authorizeRequest
      });
      const redirectURI = `${accountFrontend}${queryString}`;
      window.location.href = encodeURI(redirectURI);

    } else if (state.url.includes('/redirect') && state.root.queryParams.code && state.root.queryParams.state) {
      this.loginParams.code = state.root.queryParams.code;
      this.loginParams.state = state.root.queryParams.state;

      this.authService.loginFromAccount(this.loginParams.state, this.loginParams.code).subscribe(res => {
        if (res) {
          const returnUrl: string = this.appConfigService.getReturnUrl() || '/';
          const returnUrlTree: UrlTree = this.router.parseUrl(returnUrl);
          if (!('lang' in returnUrlTree.queryParams)) {
            returnUrlTree.queryParams['lang'] = this.appConfigService.getLanguage();
          }
          this.appConfigService.removeReturnUrlCookie();
          this.router.navigateByUrl(returnUrlTree.toString());
        } else {
          this.router.navigate([]);
        }
      }, (error) => {
        console.log(error);
        this.router.navigate([]);
      });

    }
    else if (state.url.includes('/b2c/login')) {
      const clientId = CLIENT_ID.B2C.toString();
      return this.handleLogin(state, clientId, lang => this.login(lang, clientId));
    }
    else if (state.url.includes('/login')) {
      const clientId = CLIENT_ID.ASCENDTRAVEL.toString();
      return this.handleLogin(state, clientId, lang => this.login(lang, clientId));

    } else if (state.url.includes('/joinus')) {
      return this.handleLogin(state, CLIENT_ID.ASCENDTRAVEL.toString(), lang => this.joinUs(lang));

    } else {
      return true;
    }
  }

  handleLogin(state: RouterStateSnapshot, clientId: string, redirectToAccount: (lang: string) => void): Observable<boolean> {
    const queryParams = state.root.queryParams;
    const lang = queryParams.lang ? queryParams.lang : Language.th;

    return this.authService.validateToken(this.authService.getToken()).map(isLoggedIn => {
      if (!isLoggedIn) {
        redirectToAccount(lang);
        return false;
      }
      const correctLoginPath = this.getCorrectLoginPath(clientId, this.authService.getTokenClientId());
      if (correctLoginPath) {
        this.router.navigate([correctLoginPath], { queryParams: queryParams });
        return false;
      }
      // WHY: per AT-5081, logged-in users skip the account page and go straight to search
      window.location.href = `${redirectURIV2}/?lang=${lang}`;
      return false;
    });
  }

  // WHY: per AT-5081, login paths must match the token's client — B2B (1) belongs on /b2b/login, B2C (3) on /b2c/login
  getCorrectLoginPath(pathClientId: string, tokenClientId: string): string {
    const b2bClientId = CLIENT_ID.ASCENDTRAVEL.toString();
    const b2cClientId = CLIENT_ID.B2C.toString();
    if (pathClientId === b2cClientId && tokenClientId === b2bClientId) {
      return '/b2b/login';
    }
    if (pathClientId === b2bClientId && tokenClientId === b2cClientId) {
      return '/b2c/login';
    }
    return undefined;
  }

  login(lang: string, clietId: string) {
    let queryParams: any = this.authService.generateAuthorizeRequest(undefined, clietId);
    queryParams = {
      ...queryParams,
      lang: lang
    }
    window.location.href = encodeURI(`${accountFrontend}${this.utilitiesService.objectToQueryString(queryParams)}`);
  }

  joinUs(lang: string) {
    const queryParams = {
      page: 'joinUs',
      ...this.authService.generateAuthorizeRequest(),
      lang: lang
    };
    window.location.href = encodeURI(`${accountFrontend}${this.utilitiesService.objectToQueryString(queryParams)}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guard/extra.guard.ts